var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.loading)?_c('div',[(!_vm.user.authorized())?_c('div',[_c('auth',{model:{value:(_vm.user),callback:function ($$v) {_vm.user=$$v},expression:"user"}})],1):_vm._e(),(_vm.user.authorized())?_c('div',[_c('navigation'),_c('router-view')],1):_vm._e()]):_vm._e(),(_vm.loading)?_c('div',[_c('b-spinner')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }